import React from "react";
import ReactDOM from "react-dom/client";
import "./output.css";
import reportWebVitals from "./reportWebVitals";
import { MantineProvider } from "@mantine/core";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import App from "./App";
import tiTheme from "./themes/tiTheme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <MantineProvider withGlobalStyles withNormalizeCSS>
      <ThemeProvider theme={tiTheme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </MantineProvider>
  </React.StrictMode>
);

reportWebVitals();
